<ng-container>
  <div class="main-information-container px-4">
    <div>
      <div [formGroup]="annotationAddComment">
        <div class="heading">
          <span>Information</span>
        </div>
        <div class="comment-container-test-detail">
          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Comment</mat-label>
            <textarea rows="10" matInput formControlName="comments"></textarea>
            <mat-error>{{'Required field'}}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</ng-container>
